import { createFormHook } from '@tanstack/react-form'

import {
  AutoResizeTextarea,
  FormBillCategorySelect,
  FormCheckbox,
  FormCheckboxList,
  FormCompanyTypeSelect,
  FormContactTypeSelect,
  FormCountrySelect,
  FormCountryTagsInput,
  FormCurrencySelect,
  FormCustomsRequiredSelect,
  FormCustomsResponsiblePartySelect,
  FormDatePicker,
  FormInput,
  FormLocaleSelect,
  FormOrganisationSelect,
  FormPasswordInput,
  FormPaymentMethodSelect,
  FormPaymentStatusSelect,
  FormPaymentTermsInput,
  FormPhoneInput,
  FormPodRequirementSelect,
  FormProductSelect,
  FormRoleSelect,
  FormSourceSelect,
  FormSwitch,
  FormTagsInput,
  FormTextInput,
  FormTimeInput,
  FormUkRegionsTagsInput,
  PackagingTypeInput,
  PalletsInput,
  VehicleTypeInput,
  WeightInput,
} from '../inputs'
import { FormUserSelect } from '../inputs/card/form-user-select.tsx'
import { FormTextarea } from '../inputs/form-textarea.tsx'
import { ContactInput } from '../inputs/company/contact-input.tsx'
import { UserInput } from '../inputs/user/user-input.tsx'
import { FormUserMultiSelect } from '../inputs/user/form-user-multi-select.tsx'
import { FormUserStatusSelect } from '../inputs/card/form-user-status-select.tsx'
import { CompanyLocationInput } from '../inputs/location/company-location-input.tsx'

import { fieldContext, formContext } from './form-context'
export { fieldContext, formContext, useFieldContext, useFormContext } from './form-context'

export const appFieldComponents = {
  AutoResizeTextarea,
  checkbox: FormCheckbox,
  CheckboxList: FormCheckboxList,
  CompanyLocationInput,
  ContactInput,
  DatePicker: FormDatePicker,
  FormBillCategorySelect,
  FormCompanyTypeSelect,
  FormContactTypeSelect,
  FormCountrySelect,
  FormCountryTagsInput,
  FormCurrencySelect,
  FormCustomsRequiredSelect,
  FormCustomsResponsiblePartySelect,
  FormLocaleSelect,
  FormOrganisationSelect,
  FormPaymentMethodSelect,
  FormPaymentStatusSelect,
  FormPhoneInput,
  FormPodRequirementSelect,
  FormProductSelect,
  FormRoleSelect,
  FormSourceSelect,
  FormTagsInput,
  FormTextInput,
  FormTimeInput,
  FormUkRegionsTagsInput,
  FormUserMultiSelect,
  FormUserSelect,
  FormUserStatusSelect,
  Input: FormInput,
  PackagingTypeInput,
  PalletsInput,
  PasswordInput: FormPasswordInput,
  PaymentTermsInput: FormPaymentTermsInput,
  Switch: FormSwitch,
  Textarea: FormTextarea,
  TimeInput: FormTimeInput,
  UserInput,
  VehicleTypeInput,
  WeightInput,
}

export const { useAppForm, withFieldGroup, withForm } = createFormHook({
  fieldComponents: appFieldComponents,
  fieldContext,
  formComponents: {},
  formContext,
})
